import {
	Component,
	OnInit,
	ViewChild,
	AfterViewInit,
	ElementRef,
	Input,
	EventEmitter,
	Output,
	OnChanges,
	SimpleChanges
} from '@angular/core'
import { NgImageSliderComponent } from 'ng-image-slider'
import { ViewValidation } from '../../_helpers/ViewValidation'
import { Address } from '../../models/Address'
import { LabelIcons } from 'src/app/models/LabelIcons'
import { loadModules, loadScript } from 'esri-loader'
import { BehaviorSubject } from 'rxjs'
import MarkerClusterer from '@google/markerclustererplus'
import { Company } from 'src/app/models/Company'
import { CompanyService } from 'src/app/services/company.service'
import { UserAdmin } from 'src/app/models/UserAdmin'
import {
	getLoggedUser,
	getViewOnlyPinsSelected,
	setViewOnlyPinsSelected
} from 'src/app/_helpers/LocalStorage'
import {
	DetailsFromClick,
	FiltersState,
	QuestionsFilters
} from 'src/app/models/DetailsFromClick'
import { PlantingService } from 'src/app/services/planting.service'
import { InventoryService } from 'src/app/services/inventory.service'
import { DemandService } from 'src/app/services/demand.service'
import { OperationServiceService } from 'src/app/services/operation.service.service'
import { PinMapDto } from 'src/app/models/PinsFromMapView'
import { SchedulingService } from 'src/app/services/scheduling.service'
import { Region } from 'src/app/models/Region'
import { RegionsService } from 'src/app/services/regions.service'
import { Router } from '@angular/router'
import { NotificationService } from 'src/app/services/notification.service'

@Component({
	selector: 'app-map-view',
	templateUrl: './map-view.component.html'
})
export class MapView implements OnInit, AfterViewInit, OnChanges {
	@Output() public requestCacheUpdate: EventEmitter<any> = new EventEmitter()
	@Output() public updatePin: EventEmitter<any> = new EventEmitter()

	@Input() public allTrees: Array<PinMapDto> = []
	@Input() public idsMongoSelected: Array<string> = []
	@Input() public filtersData: QuestionsFilters
	@Input() public mapsWithLegend: boolean = true
	@Input() public findTreeFromClickTable: string = ''
	@Input() public mapType:
		| 'inventoryMap'
		| 'inventoryScheduleMap'
		| 'plantingOpportunityMap'
		| 'plantingHistoricMap'
		| 'appraisalMap'
		| 'scheduleAppraisalMap'
		| 'operationMap'
		| 'operationScheduleMap'
		| 'treeMap'
	@Input() public modalFilterStyle: boolean = false

	public companyId: string = localStorage.getItem('companyId')
	public company: Company = new Company()
	public sessionUser: UserAdmin = getLoggedUser()
	public assignments: Array<string> = []
	public allRegions: Array<Region> = []

	public myMap: google.maps.Map
	public markers: Array<google.maps.Marker> = []
	public markerDragged: google.maps.Marker;
	public startLocationBeforeDrag: Address = new Address()
	public endLocationAfterDrag: Address = new Address()
	public treeDraggedId: string = '';
	public polygonsDelimitAllRegions: Array<google.maps.Polygon> = []
	public markerInfowindow = new google.maps.InfoWindow()
	public regionInfoWindow = new google.maps.InfoWindow()
	public prevMarker: google.maps.Marker = null
	public previousMarker: any
	public filterPerState: Array<FiltersState>
	public viewOnlyPinsSelected: boolean = getViewOnlyPinsSelected()

	public mapArcgis
	public viewArcgis
	public layerMapArcgis: String = 'arcgis-topographic'
	public layerlabelsForArcGis: any
	public labelsGraphics = []

	public markerCluster: MarkerClusterer
	public treeSelected: DetailsFromClick = new DetailsFromClick()

	public address: Address = new Address()
	public ViewValidation: ViewValidation = new ViewValidation()
	public isLoading: boolean = true
	public enableButtonUpdateCache: boolean = false

	public theAmountTreesFiltered: number = 0
	public labelIcons: Array<LabelIcons> = []

	public loaded$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false)

	public searchAddress: string = ''
	public isAdmin: boolean = false
	public hasAccessProtectedRouteReport: boolean = false
	public withCustomerBread: boolean = false
	public viewMarkersClusterided: boolean = true
	public modalFilterVisible: boolean = false
	public viewAllRegionsInMap: boolean = true
	public dragAuthorized: boolean = false
	public isArcgis: boolean = false
	public viewLabels: boolean = false
	public showPinMoveAlertModal: boolean = false;

	public LIMIT_PINS = 200

	public showModalLimitSelection = false
	public showModalOutOfDateWithPermission = false
	public showModalOutOfDateWithoutPermission = false

	// Select from pin

	public isEnabledSelectMarkersFromMap: boolean = false
	public idMongoFromSelectedMarkersFromMap: Array<string> = []
	public markersSelectedFromMap: Array<google.maps.Marker> = []

	public idMongoFromSelectedMarkersFromPolygon: Array<string> = []
	public markersSelectedFromPolygon: Array<google.maps.Marker> = []

	public permittedToScheduleFromMap: boolean = false
	private scheduleMaps: Array<{ mapName: string; hasPermission: boolean }> = [
		{
			mapName: 'inventoryScheduleMap',
			hasPermission:
				Boolean(
					this.sessionUser.assignments.includes('INVENTORY_SCHEDULE_CREATE')
				) || Boolean(this.sessionUser.roles.includes('GENERAL_ADMIN'))
		},
		{
			mapName: 'operationScheduleMap',
			hasPermission:
				Boolean(
					this.sessionUser.assignments.includes(
						'OPERATION_SERVICE_SCHEDULE_CREATE'
					)
				) || Boolean(this.sessionUser.roles.includes('GENERAL_ADMIN'))
		},
		{
			mapName: 'scheduleAppraisalMap',
			hasPermission:
				Boolean(
					this.sessionUser.assignments.includes('APPRAISAL_SCHEDULE_CREATE')
				) || Boolean(this.sessionUser.roles.includes('GENERAL_ADMIN'))
		},
		{
			mapName: 'plantingOpportunityMap',
			hasPermission:
				Boolean(
					this.sessionUser.assignments.includes('PLANTING_SCHEDULE_CREATE')
				) || Boolean(this.sessionUser.roles.includes('GENERAL_ADMIN'))
		}
	]

	// Regions / Polygons

	public startedPolygon = false
	public isEnabledSelectMarkersFromPolygon = false
	private disableSelectMarkersFromPolygonIfZoomIsLessThanSixteen = true
	public region = new Region()

	public polygonDelimitRegion: google.maps.Polygon = new google.maps.Polygon({
		strokeOpacity: 0.6,
		strokeWeight: 2,
		fillOpacity: 0.5
	})

	public createPolygonTool = new google.maps.drawing.DrawingManager({
		drawingMode: google.maps.drawing.OverlayType.POLYGON,
		drawingControl: false,
		polygonOptions: {
			strokeOpacity: 0.6,
			strokeWeight: 2,
			fillOpacity: 0.5
		}
	})

	@ViewChild('nav')
	public slider: NgImageSliderComponent
	public imageObject: Array<object>
	public prevImageClick() {
		this.slider.prev()
	}
	public nextImageClick() {
		this.slider.next()
	}

	constructor(
		private elementRef: ElementRef,
		private companyService: CompanyService,
		private plantingService: PlantingService,
		private inventoryService: InventoryService,
		private demandService: DemandService,
		private operationServiceService: OperationServiceService,
		private schedulingService: SchedulingService,
		private readonly regionsService: RegionsService,
		private readonly router: Router,
		private readonly notificationService: NotificationService
	) {
		this.loaded$.subscribe(loaded => {
			if (!loaded) {
				loadScript({
					url: 'https://js.arcgis.com/4.23/'
				})
					.then(() => {
						this.loaded$.next(true)
					})
					.catch(err => this.loaded$.next(true))
			}
		})
	}

	public ngOnChanges(changes: SimpleChanges): void {
		if (changes.findTreeFromClickTable && (this.myMap || this.mapArcgis)) {
			this.getInfosMouseClickFromTable(this.findTreeFromClickTable)
		}

		if (changes.allTrees) {
			this.updateMapCache()
		}
	}

	public ngAfterViewInit(): void {
		this.elementRef.nativeElement
			.querySelector('#searchAddress')
			.addEventListener('change', this.searchByCepOrAddress.bind(this))
	}

	public async ngOnInit(): Promise<void> {
		localStorage.removeItem('cameFromScheduleMap')

		await this.fetchCompany()
		this.fetchSessionUser()
		await this.fetchRegions()

		this.screenWithCustomerBread()
		await this.setFilterPerState()

		setTimeout(() => {
			this.changeMap()
		}, 1200)
	}

	public async changeMap(action: 'INIT' | 'CHANGE' = 'INIT') {
		const mapViewGoogleMaps = document.getElementsByClassName('my-map')[0]
		if (mapViewGoogleMaps) {
			mapViewGoogleMaps.innerHTML = ''
		}

		const mapViewArcgis = document.getElementsByClassName('my-map-arcgis')[0]
		if (mapViewArcgis) {
			mapViewArcgis.innerHTML = ''
		}

		if (action == 'CHANGE') {
			localStorage.setItem(
				'mapVisible',
				this.isArcgis ? 'arcgis' : 'google-maps'
			)
		}

		this.resetOnMapChange()

		const mapPreference = localStorage.getItem('mapVisible')
		if (
			!mapPreference ||
			mapPreference == 'google-maps' ||
			(mapPreference == 'arcgis' && !this.company.mandatoryArcGis) ||
			(mapPreference != 'arcgis' && mapPreference != 'google-maps')
		) {
			localStorage.setItem('mapVisible', 'google-maps')

			this.isArcgis = false

			setTimeout(() => {
				this.initMap()
			}, 1000)
		} else if (mapPreference == 'arcgis' && this.isArcgis) {
			this.isArcgis = true

			localStorage.setItem('mapVisible', 'arcgis')
			this.initializeMapArcgis()
		} else {
		}
	}

	public resetOnMapChange(): void {
		this.treeSelected = null
	}

	public createElements(elements) {
		const elementsCreated = []

		elements.forEach(element => {
			const elementCreated = document.createElement(element.element)
			elementCreated.setAttribute(element.attribute, element.valueAttribute)
			element.style && elementCreated.setAttribute('style', element.style)

			if (element.id) {
				elementCreated.setAttribute('id', element.id)
			}

			if (element.text) {
				elementCreated.innerHTML = element.text
			}

			if (element.icon) {
				const iconBase: string = `assets/images/icon/${element.icon}-icon.svg`

				const svgIcon = document.createElement('img')
				svgIcon.setAttribute('src', iconBase)

				elementCreated.appendChild(svgIcon)

				if (element.icon == 'only-selected') {
					elementCreated.disabled =
						this.idsMongoSelected.length == 0 || !this.viewOnlyPinsSelected
					elementCreated.setAttribute('id', 'only-selected-map-button')
					this.setShowOnlySelectButtonActive('only-selected-map-button')
				}

				if (element.icon == 'refresh' && !this.enableButtonUpdateCache) {
					return
				}
			}

			if (element.title) {
				elementCreated.title = element.title
			}

			const handleClickButton = (functionName: string) => {
				if (typeof this[functionName] === 'function') {
					if (functionName == 'modalFilteractivate') {
						this[functionName](!this.modalFilterVisible)
					} else if (functionName == 'changeViewPinsFromMap') {
						this.viewOnlyPinsSelected = !this.viewOnlyPinsSelected
						this[functionName](false)
						this.setShowOnlySelectButtonActive('only-selected-map-button')
					} else {
						this[functionName]()
					}
				} else {
					console.error(`A função ${functionName} não existe.`)
				}
			}

			element.action &&
				elementCreated.addEventListener('click', () => {
					handleClickButton(element.action)
				})

			if (element.balloon) {
				const ballonBase: string = `assets/images/balloon-${element.balloon}.svg`
				const ballon = document.createElement('img')
				ballon.style.display = 'none'

				ballon.setAttribute('src', ballonBase)

				const divContent = document.createElement('div')
				divContent.setAttribute('class', 'conteiner-button arcgis')

				divContent.appendChild(ballon)
				divContent.appendChild(elementCreated)

				elementCreated.addEventListener('mouseover', () => {
					ballon.style.display = 'block'
				})

				elementCreated.addEventListener('mouseout', () => {
					ballon.style.display = 'none'
				})

				elementsCreated.push(divContent)
			} else {
				elementsCreated.push(elementCreated)
			}
		})
		return elementsCreated
	}

	public createElementsMap(classMain, elements): void {
		const containerMain = document.getElementsByClassName(classMain)[0]
		let elementsBeforeCreate

		if (!this.mapsWithLegend) {
			elementsBeforeCreate = elements.filter(el => !el.valueAttribute.includes('legend')
			)
		} else {
			elementsBeforeCreate = elements
		}

		const elementsCreated = this.createElements(elementsBeforeCreate)
		const containerMap = elementsCreated[0]

		containerMain.insertBefore(containerMap, containerMain.children[1])

		elementsCreated.forEach((element, index) => {
			const qtdItensFormMap = this.mapsWithLegend ? 4 : 3
			const isContainerChildToContainerMap = index > 0 && index <= 1
			const isContainerChildToChildContainerMap =
				index > 1 && index <= qtdItensFormMap

			if (isContainerChildToContainerMap) {
				containerMap.appendChild(element)
			} else if (isContainerChildToChildContainerMap) {
				const childContainerMap = elementsCreated[1]
				childContainerMap.appendChild(element)
			} else if (index > qtdItensFormMap) {
				const container = elementsCreated[qtdItensFormMap]
				container.appendChild(element)
			}
		})
	}

	public async initMap(): Promise<void> {
		this.region.companyId = this.companyId

		if (!this.region.color) {
			this.region.color = '#a9a9a9'
		}

		this.createElementsMap('map-content', [
			{
				element: 'div',
				attribute: 'class',
				valueAttribute: 'conteiner',
				style:
					'background: white; border-radius: 8px; box-shadow: 0 10px 35px 0 rgba(0, 0, 0, 0.16);'
			},
			{
				element: 'div',
				attribute: 'class',
				valueAttribute: 'my-map col-12'
			},
			{
				element: 'div',
				attribute: 'id',
				valueAttribute: 'map-principal',
				style: 'height: 530px'
			},
			{
				element: 'div',
				attribute: 'id',
				valueAttribute: 'legend'
			}
		])

		this.removeWhiteConteiner()
		const mapView = document.getElementById('map-principal')

		let lat
		let lng

		const geocoder: any = new google.maps.Geocoder()

		try {
			await geocoder.geocode(
				{ address: this.company.address.street },
				async (results, status) => {
					if (status === google.maps.GeocoderStatus.OK) {
						lat = results[0].geometry.location.lat()
						lng = results[0].geometry.location.lng()
					}
				}
			)
		} catch (err) {
			console.error('Error on get geocode', err)
		}

		const map: google.maps.Map = new google.maps.Map(mapView, {
			zoom: 13,
			center: new google.maps.LatLng(lat, lng),
			gestureHandling: 'cooperative'
		})

		map.setOptions({
			styles: [
				{
					featureType: 'poi',
					stylers: [{ visibility: 'off' }]
				},
				{
					featureType: 'transit.station.bus',
					stylers: [{ visibility: 'off' }]
				}
			]
		})

		this.myMap = map

		let trees = this.allTrees

		const viewOnlyPinsSelected = Boolean(
			this.viewOnlyPinsSelected && this.idsMongoSelected.length > 0
		)

		if (viewOnlyPinsSelected) {
			trees = this.allTrees.filter(tree => {
				const treeIsSelected = this.idsMongoSelected.includes(tree.idMongo)
				if (treeIsSelected) {
					return tree
				}
			})
		}

		google.maps.event.addListenerOnce(map, 'idle', async () => {
			this.addMarkers(this.myMap, trees)
			this.theAmountTreesFiltered = trees.length
		})

		const iconsLabel = this.filterPerState.map(state => {
			const currentStateTree: string = state.text.toUpperCase()
			const backgroundColorRandom = this.getRandomColor()
			const marker = {
				styleMarker: `width: 14px; height: 14px; border-radius: 7px; background-color: ${
					state.color ? state.color : backgroundColorRandom
				}; margin-right: 10px;`,
				colorPin: state.color ? state.color : backgroundColorRandom
			}

			return {
				name: currentStateTree,
				styleMarker: marker.styleMarker,
				colorPin: marker.colorPin,
				withSuppression: state.color.includes('unavailable-icon.svg')
			}
		})

		this.labelIcons = iconsLabel

		if (this.mapsWithLegend) {
			let legend = document.getElementById('legend')

			if (!legend) {
				const newDiv = document.createElement('div')
				newDiv.setAttribute('id', 'legend')
				document.getElementsByClassName('maps')[0].appendChild(newDiv)

				legend = document.getElementById('legend')
			}

			for (const key in iconsLabel) {
				const type = iconsLabel[key]
				const name = type.name
				const styleMarker = type.styleMarker

				const div = document.createElement('div')
				div.setAttribute('class', 'legend-item')
				if(type.withSuppression) {
					div.innerHTML = 
						`<img 
							style="
								width: 16px;
    						height: 16px;" 
							src="assets/images/icon/unavailable-icon.svg"
						/> 
						<span>
							Suprimida
						</span>`
				} else {
					div.innerHTML = 
						`<div style="${styleMarker}"></div> 
						<span>${name}</span>`
				}
				legend.appendChild(div)
			}
			map.controls[google.maps.ControlPosition.LEFT_BOTTOM].push(legend)
		}

		this.insertFilterButtonInGooleMaps()

		if (this.enableButtonUpdateCache) {
			this.insertRefreshMapButtonInGooleMaps()
		}

		if (this.allRegions.length > 0) {
			this.insertShowRegionsButtonInGooleMaps()
			this.createAllRegions()
			this.showAllRegionsInMap()
		}

		this.insertShowOnlySelectedButtonInGoogleMaps()
		this.insertGroupPinsButtonInGoogleMaps()
		this.insertIdentificationTreeButtonInGoogleMaps()

		if (
			this.scheduleMaps.some(data => data.mapName.toUpperCase() == this.mapType.toUpperCase()
			)
		) {
			this.insertClearButtonInGoogleMaps()
			this.insertSelectPinsInGoogleMapsByPolygon()
			this.insertSelectPinsInGoogleMaps()
			this.permittedToScheduleFromMap = true
		}

		map.addListener('click', () => {
			this.regionInfoWindow.close()
			this.markerInfowindow.close()
		})

		const handleZoom = (zoom: number) => {
			const onlySelectButton: HTMLButtonElement = document.getElementById(
				'select-pin-from-polygon-button'
			) as HTMLButtonElement

			if (zoom < 16) {
				this.disableSelectMarkersFromPolygonIfZoomIsLessThanSixteen = true

				if (onlySelectButton) {
					onlySelectButton.disabled = true
				}
			} else {
				this.disableSelectMarkersFromPolygonIfZoomIsLessThanSixteen = false

				if (onlySelectButton) {
					onlySelectButton.disabled = false
				}
			}
		}

		map.addListener('zoom_changed', () => {
			handleZoom(map.getZoom())
		})
	}

	private getMarkersInsidePolygon(polygon: google.maps.Polygon) {
		for (const marker of this.markers) {
			if (
				google.maps.geometry.poly.containsLocation(
					marker.getPosition(),
					polygon
				)
			) {
				google.maps.event.trigger(marker, 'polygon')
			}

			if (this.markersSelectedFromPolygon.length >= this.LIMIT_PINS + 1) {
				break
			}
		}

		console.log(
			'Markers selected from polygon',
			this.markersSelectedFromPolygon.length
		)
	}

	public fillColor() {
		this.polygonDelimitRegion.setOptions({
			fillColor: this.region.color
		})
	}

	public enableOrDesableBtnClear(disabled: boolean) {
		const button: HTMLButtonElement = document.getElementById(
			'btn-clear-coordinates-region'
		) as HTMLButtonElement

		button.disabled = disabled
	}

	public removePolygonToolFromMap() {
		this.createPolygonTool.setMap(null)
	}

	public insertPolygonInMap() {
		this.polygonDelimitRegion.setOptions({
			fillColor: this.region.color
		})

		this.polygonDelimitRegion.setPath(this.region.coordinates)

		this.polygonDelimitRegion.setMap(this.myMap)
	}

	public clearCoordinates() {
		this.region.coordinates = []
		this.removePolygonFromMap()

		this.enableOrDesableBtnClear(true)
	}

	public removePolygonFromMap() {
		if (this.polygonDelimitRegion) {
			this.polygonDelimitRegion.setMap(null)
		}
	}

	public insertPolygonToolInMap() {
		this.createPolygonTool.setMap(this.myMap)
	}

	public async addMarkers(map: google.maps.Map, tree: Array<PinMapDto>) {
		if (this.markers.length > 0) {
			this.markers.forEach(marker => marker.setMap(null))
			this.markers.length = 0
		}

		if (this.markerCluster != undefined) {
			this.markerCluster.clearMarkers()
		}

		if (tree.length > 0) {
			const isMapSchedule = this.scheduleMaps.some(data => data.mapName.toUpperCase() == this.mapType.toUpperCase()
			)

			const pinIsAbleToSchedule = (treeObj: PinMapDto) => {
				return isMapSchedule && this.mapType == 'plantingOpportunityMap'
					? treeObj.isToSchedule
					: treeObj.answer &&
							(treeObj.answer.toUpperCase() === 'AGENDAR' ||
								treeObj.answer.toUpperCase() === 'CANCELADO')
			}

			tree.forEach(treeObj => {
				const positionMap = {
					position: new google.maps.LatLng(
						Number(treeObj.lat),
						Number(treeObj.lng)
					)
				}

				const dap = treeObj.dapCap && Number(treeObj.dapCap)
				const stateTree =
					this.mapType != 'operationMap'
						? treeObj.answer
						: treeObj.handleOperations[0]

				const showIndividualPins = Boolean(!this.viewMarkersClusterided)

				for (const label of this.labelIcons) {
					if (
						stateTree &&
						stateTree.toUpperCase() == label.name.toUpperCase()
					) {
						const marker = new google.maps.Marker({
							position: positionMap.position,
							icon: treeObj.treeSuppressed ? 
								'assets/images/icon/unavailable-icon.svg' : this.getPinIcon(dap, label.colorPin), 
							map: showIndividualPins ? map : null,
							draggable: Boolean(
								this.isAdmin ||
									this.dragAuthorized ||
									this.userAuthorizedToDrag(treeObj.responsible)
							),
							title: treeObj && treeObj.identification ? String(treeObj.identification) : null,
						})

						this.markers.push(marker)

						google.maps.event.addListener(marker, 'dragstart', event => {
							this.startLocationBeforeDrag.lat = event.latLng.lat();
							this.startLocationBeforeDrag.lng = event.latLng.lng();
						});

						google.maps.event.addListener(marker, 'dragend', event => {
							this.markerDragged = marker;

							this.endLocationAfterDrag.lat = event.latLng.lat();
							this.endLocationAfterDrag.lng = event.latLng.lng();
							this.treeDraggedId = treeObj.idMongo;
							
							this.showPinMoveAlertModal = true;
						})

						marker.addListener(
							'click',
							this.getInfosMouseClickFromTree.bind(
								this,
								marker,
								treeObj.idMongo,
								this.company._id
							)
						)

						if (pinIsAbleToSchedule(treeObj)) {
							marker.addListener(
								'polygon',
								this.selectPinFromPolygon.bind(this, marker, {
									isMapSchedule,
									idMongo: treeObj.idMongo,
									dapCap: treeObj.dapCap && Number(treeObj.dapCap),
									handlerOperation:
										treeObj &&
										treeObj.handleOperations &&
										treeObj.handleOperations.length > 0 &&
										treeObj.handleOperations[0],
									answer: treeObj.answer
								})
							)

							marker.addListener(
								'click',
								this.selectPinFromMap.bind(this, marker, {
									isMapSchedule,
									idMongo: treeObj.idMongo,
									dapCap: treeObj.dapCap && Number(treeObj.dapCap),
									handlerOperation:
										treeObj &&
										treeObj.handleOperations &&
										treeObj.handleOperations.length > 0 &&
										treeObj.handleOperations[0],
									answer: treeObj.answer
								})
							)
						}
					}
				}
			})
		}

		const options = {
			maxZoom: 20,
			styles: [
				{
					height: 53,
					url: 'https://arbolink-app.s3.amazonaws.com/2d1b-aa82-c1.png',
					width: 53
				},
				{
					height: 56,
					url: 'https://arbolink-app.s3.amazonaws.com/ee44-8e61-c2.png',
					width: 56
				},
				{
					height: 66,
					url: 'https://arbolink-app.s3.amazonaws.com/9f6f-98ec-c3.png',
					width: 66
				},
				{
					height: 78,
					url: 'https://arbolink-app.s3.amazonaws.com/0402-3f54-c4.png',
					width: 78
				},
				{
					height: 90,
					url: 'https://arbolink-app.s3.amazonaws.com/f1fa-e98f-c5.png',
					width: 90
				}
			]
		}

		if (this.viewMarkersClusterided) {
			this.markerCluster = new MarkerClusterer(
				this.myMap,
				this.markers,
				options
			)

			console.log('Mapa clusterizado')
		}

		this.isLoading = false
	}

	public async clusteredPins() {
		const visibleMap = localStorage.getItem('mapVisible')

		if (visibleMap == 'google-maps') {
			const filtersSelected = this.filterPerState.filter(filter => filter.checked
			)

			let trees: Array<PinMapDto> = this.allTrees

			const viewOnlyPinsSelected = Boolean(
				this.viewOnlyPinsSelected && this.idsMongoSelected.length > 0
			)

			if (viewOnlyPinsSelected) {
				trees = this.filterByIdmongoSelected()
			}

			if (filtersSelected.length > 0) {
				trees = this.filterByStateSelected(trees, filtersSelected)
			}

			this.addMarkers(this.myMap, trees)
		}
	}

	public selectPinFromPolygon(
		marker: google.maps.Marker,
		data: {
			isMapSchedule: boolean
			idMongo: string
			dapCap: number
			handlerOperation: string
			answer: string
		}
	) {
		if (!this.isEnabledSelectMarkersFromPolygon || !data.isMapSchedule) {
			return
		}

		this.setMarkerDataFromSelect(marker, data, 'POLYGON')
	}

	public selectPinFromMap(
		marker: google.maps.Marker,
		data: {
			isMapSchedule: boolean
			idMongo: string
			dapCap: number
			handlerOperation: string
			answer: string
		}
	) {
		if (!this.isEnabledSelectMarkersFromMap || !data.isMapSchedule) {
			return
		}

		this.setMarkerDataFromSelect(marker, data, 'MAP')
	}

	private guardLimitPinsOnSelection() {
		if (
			this.markersSelectedFromMap.length +
				this.markersSelectedFromPolygon.length >=
			this.LIMIT_PINS
		) {
			this.showModalLimitSelection = true
			return false
		}

		return true
	}

	private setMarkerDataFromSelect(
		marker: google.maps.Marker,
		data: {
			isMapSchedule: boolean
			idMongo: string
			dapCap: number
			handlerOperation: string
			answer: string
		},
		type: 'MAP' | 'POLYGON'
	) {
		const selectedIds =
			type === 'MAP'
				? this.idMongoFromSelectedMarkersFromMap
				: this.idMongoFromSelectedMarkersFromPolygon
		const alreadySelectedIndex = selectedIds.findIndex(id => id === data.idMongo
		)
		const isAlreadySelected = alreadySelectedIndex !== -1

		if (type === 'MAP') {
			const insidePolygonIndex =
				this.idMongoFromSelectedMarkersFromPolygon.findIndex(id => id === data.idMongo
				)
			const isInsidePolygon = insidePolygonIndex !== -1

			if (isInsidePolygon) {
				// Unselect from polygon
				this.markersSelectedFromPolygon.splice(insidePolygonIndex, 1)
				this.idMongoFromSelectedMarkersFromPolygon.splice(insidePolygonIndex, 1)
				this.setPinIcon(marker, data, isAlreadySelected)
				return
			}
		} else if (type === 'POLYGON') {
			const isOnMap = this.idMongoFromSelectedMarkersFromMap.includes(
				data.idMongo
			)
			if (isOnMap) {
				console.log('Pin selected on map')
				return
			}
		}

		if (!isAlreadySelected) {
			if (!this.guardLimitPinsOnSelection()) {
				return
			}

			if (type === 'MAP') {
				this.markersSelectedFromMap.push(marker)
				this.idMongoFromSelectedMarkersFromMap.push(data.idMongo)
			} else {
				this.markersSelectedFromPolygon.push(marker)
				this.idMongoFromSelectedMarkersFromPolygon.push(data.idMongo)
			}
		} else {
			if (type === 'MAP') {
				this.markersSelectedFromMap.splice(alreadySelectedIndex, 1)
				this.idMongoFromSelectedMarkersFromMap.splice(alreadySelectedIndex, 1)
			} else {
				this.markersSelectedFromPolygon.splice(alreadySelectedIndex, 1)
				this.idMongoFromSelectedMarkersFromPolygon.splice(
					alreadySelectedIndex,
					1
				)
			}
		}

		this.setPinIcon(marker, data, !isAlreadySelected)
	}

	private setPinIcon(
		marker: google.maps.Marker,
		data: {
			dapCap: number
			answer: string
		},
		isNewSelection: boolean
	) {
		for (const label of this.labelIcons) {
			if (
				data.answer &&
				data.answer.toUpperCase() === label.name.toUpperCase()
			) {
				marker.setIcon(
					this.getPinIcon(data.dapCap, label.colorPin, isNewSelection)
				)
				break
			}
		}
	}

	public async getInfosMouseClickFromTree(marker, treeId, companyId) {
		if (
			this.isEnabledSelectMarkersFromMap ||
			this.isEnabledSelectMarkersFromPolygon
		) {
			return
		}

		let content: string

		if (this.mapType == 'plantingOpportunityMap') {
			this.treeSelected = await this.plantingService
				.getClickPlantingOpportunity(treeId, companyId)
				.toPromise()
		}
		if (this.mapType == 'plantingHistoricMap') {
			this.treeSelected = await this.plantingService
				.getClickPlanting(treeId, companyId)
				.toPromise()
		}
		if (this.mapType == 'inventoryMap') {
			this.treeSelected = await this.inventoryService
				.getClickTree(treeId, companyId)
				.toPromise()
		}
		if (this.mapType == 'scheduleAppraisalMap') {
			this.treeSelected = await this.schedulingService
				.getClickScheduleDemand(treeId, this.companyId)
				.toPromise()
		}
		if (this.mapType == 'appraisalMap') {
			this.treeSelected = await this.demandService
				.getClickTree(treeId, this.companyId)
				.toPromise()
		}
		if (this.mapType == 'operationScheduleMap') {
			this.treeSelected = await this.operationServiceService
				.getClickScheduleTree(treeId, this.companyId)
				.toPromise()
		}
		if (this.mapType == 'operationMap') {
			this.treeSelected = await this.operationServiceService
				.getClickTree(treeId, this.companyId)
				.toPromise()
		}
		if (this.mapType == 'inventoryScheduleMap') {
			this.treeSelected = await this.inventoryService
				.getScheduleTreeInfos(treeId, this.companyId)
				.toPromise()
		}

		content = this.createPopupForMap(this.treeSelected)

		this.markerInfowindow.setContent(content)
		this.markerInfowindow.setOptions({
			disableAutoPan: true
		})
		this.markerInfowindow.open(this.myMap, marker)
	}

	public async initializeMapArcgis() {
		this.createElementsMap('map-content', [
			{
				element: 'div',
				attribute: 'class',
				valueAttribute: 'conteiner',
				style:
					'background: white; border-radius: 8px; box-shadow: 0 10px 35px 0 rgba(0, 0, 0, 0.16);'
			},
			{
				element: 'div',
				attribute: 'class',
				valueAttribute: 'my-map-arcgis col-12'
			},
			{
				element: 'div',
				attribute: 'id',
				valueAttribute: 'map-principal-arcgis',
				style: 'height: 530px'
			},
			{
				element: 'div',
				attribute: 'id',
				valueAttribute: 'legend-arcgis'
			},
			{
				element: 'div',
				attribute: 'class',
				valueAttribute: 'container-functions-map-arcgis'
			},
			{
				element: 'button',
				attribute: 'id',
				valueAttribute: 'buttonTypesMap',
				action: 'toggleTypesLayerMap',
				text: 'Mapa'
			},
			{
				element: 'button',
				attribute: 'id',
				valueAttribute: 'buttonSateliteArcgis',
				action: 'toggleLayerSatelite',
				text: 'Satélite'
			},
			{
				element: 'button',
				attribute: 'class',
				valueAttribute: 'btn-google-maps refresh-button arcgis',
				action: 'requestMapCacheUpdate',
				icon: 'refresh',
				title: 'Atualizar mapa'
			}
		])
		this.removeWhiteConteiner()
		const functionsMap = document.getElementsByClassName(
			'container-functions-map-arcgis'
		)[0]

		const [esriConfig, Map, MapView, Fullscreen, Zoom, BasemapGallery] =
			await loadModules([
				'esri/config',
				'esri/Map',
				'esri/views/MapView',
				'esri/widgets/Fullscreen',
				'esri/widgets/Zoom',
				'esri/widgets/BasemapGallery'
			])
		esriConfig.apiKey =
			'AAPK41dcffdbd3de44cb9613069c8c402d5eBtid297r-cx9Xl5aoYgpoyC3cHI5V30m3IlHyjtSFRMP3ln4NgRl_UNBKVn9SyVk'

		const map = new Map({
			basemap: this.layerMapArcgis
		})

		let lat
		let lng

		const geocoder: any = new google.maps.Geocoder()
		await geocoder.geocode(
			{ address: this.company.address.street },
			async (results, status) => {
				if (status === google.maps.GeocoderStatus.OK) {
					lat = results[0].geometry.location.lat()
					lng = results[0].geometry.location.lng()
				}
			}
		)

		const view = new MapView({
			map,
			center: [lng, lat],
			zoom: 16,
			container: 'map-principal-arcgis',
			ui: {
				components: ['attribution']
			}
		})

		const fullscreen = new Fullscreen({
			view
		})

		const zoom = new Zoom({
			view,
			layout: 'vertical'
		})

		const basemapGallery = new BasemapGallery({
			view
		})

		const filterButton = this.createElements([
			{
				element: 'button',
				attribute: 'class',
				valueAttribute: 'btn-google-maps regions-button arcgis with-balloon',
				action: 'modalFilteractivate',
				icon: 'filter',
				balloon: 'filters'
			},
			{
				element: 'button',
				style: 'margin-top: 10px !important',
				attribute: 'class',
				valueAttribute: 'btn-google-maps regions-button arcgis with-balloon',
				action: 'changeViewPinsFromMap',
				icon: 'only-selected',
				balloon: 'only-select'
			},
			{
				element: 'button',
				style: 'margin-top: 10px !important',
				attribute: 'class',
				valueAttribute: 'btn-google-maps regions-button arcgis',
				action: 'viewIdentificationTreeFromMap',
				icon: 'number',
				id: 'insert-label-button'
			}
		])

		view.ui.add(basemapGallery, 'top-left')
		view.ui.add(functionsMap, { position: 'top-left', index: 0 })
		view.ui.add(zoom, 'bottom-right')
		view.ui.add(fullscreen, 'top-right')
		view.ui.add(filterButton[0], 'top-right')
		view.ui.add(filterButton[1], 'top-right')
		view.ui.add(filterButton[2], 'top-right')

		this.mapArcgis = map
		this.viewArcgis = view

		let trees = this.allTrees

		const viewOnlyPinsSelected = Boolean(
			this.viewOnlyPinsSelected && this.idsMongoSelected.length > 0
		)

		if (viewOnlyPinsSelected) {
			trees = this.allTrees.filter(tree => {
				const treeIsSelected = this.idsMongoSelected.includes(tree.idMongo)
				if (treeIsSelected) {
					return tree
				}
			})
		}

		await this.createLegendArcgis()
		await this.addMarkersArcgis(map, trees)
	}

	public async createLegendArcgis() {
		const iconsLabel = this.filterPerState.map(stateTree => {
			const currentStateTree: string = stateTree.text.toUpperCase()
			const backgroundColorRandom = this.getRandomColor()
			const randomMarker = {
				styleMarker: `width: 14px; height: 14px; border-radius: 7px; background-color: ${
					stateTree.color ? stateTree.color : backgroundColorRandom
				}; margin-right: 10px;`,
				colorPin: stateTree.color ? stateTree.color : backgroundColorRandom
			}

			return {
				name: currentStateTree,
				styleMarker: randomMarker.styleMarker,
				colorPin: randomMarker.colorPin,
				withSuppression: stateTree.color.includes('unavailable-icon.svg')
			}
		})

		this.labelIcons = iconsLabel

		if (this.mapsWithLegend) {
			const hasLegend: any = document.getElementById('legend-arcgis')

			if (!hasLegend) {
				const newDiv = document.createElement('div')
				newDiv.setAttribute('id', 'legend')
				document.getElementsByClassName('maps')[0].appendChild(newDiv)
			}

			const legend = hasLegend

			for (const key in iconsLabel) {
				const type = iconsLabel[key]
				const name = type.name
				const styleMarker = type.styleMarker

				const div = document.createElement('div')
				div.setAttribute('class', 'legend-item')

				if(type.withSuppression) {
					div.innerHTML = 
						`<img 
							style="
								width: 16px;
    						height: 16px;" 
							src="assets/images/icon/unavailable-icon.svg"
						/> 
						<span>
							Suprimida
						</span>`
				} else {
					div.innerHTML = 
						`<div style="${styleMarker}"></div> 
						<span>${name}</span>`
				}
				
				legend.appendChild(div)
			}
			this.viewArcgis.ui.add(legend, 'bottom-left')
		}
	}

	public async addMarkersArcgis(map, tree: Array<PinMapDto>) {
		map.layers.removeAll()

		const [Graphic, GraphicsLayer] = await loadModules([
			'esri/Graphic',
			'esri/layers/GraphicsLayer'
		])
		const graphicsLayer = new GraphicsLayer()
		this.layerlabelsForArcGis = new GraphicsLayer()

		map.add(graphicsLayer)
		map.add(this.layerlabelsForArcGis)

		const settingsSizePin = dap => {
			if (dap > 45) {
				return 12
			} else if (dap >= 25 && dap <= 45) {
				return 10
			} else if (dap >= 10 && dap < 25) {
				return 8
			} else {
				return 6
			}
		}

		const features = []

		if (tree.length > 0) {
			tree.forEach(treeObj => {
				const positionMap = {
					position: new google.maps.LatLng(
						Number(treeObj.lat),
						Number(treeObj.lng)
					)
				}

				const stateTree =
					this.mapType != 'operationMap'
						? treeObj.answer
						: treeObj.handleOperations[0]

				for (const label of this.labelIcons) {
					if (
						stateTree &&
						stateTree.toUpperCase() == label.name.toUpperCase()
					) {
						features.push({
							...positionMap,
							colorPin: label.colorPin,
							treeObj
						})
					}
				}
			})
		}

		features.forEach(feature => {
			const dap = feature.treeObj.dapCap && feature.treeObj.dapCap

			if (
				feature.treeObj.lat != undefined &&
				feature.treeObj.lng !== undefined
			) {
				const point = {
					type: 'point',
					longitude: feature.treeObj.lng,
					latitude: feature.treeObj.lat
				}

				const simpleMarkerSymbol = feature.treeObj.treeSuppressed ? {
					type: "picture-marker",
					url: "assets/images/icon/unavailable-icon.svg",
					width: "24px",
					height: "24px"
				} : {
					type: 'simple-marker',
					color: feature.colorPin,
					size: settingsSizePin(dap),
					outline: {
						color: feature.colorPin
					}
				}

				const popupTemplate = {
					title: '',
					content: ''
				}

				const pointGraphic = new Graphic({
					geometry: point,
					symbol: simpleMarkerSymbol,
					attributes: feature.treeObj,
					popupTemplate
				})

				graphicsLayer.add(pointGraphic)
			}
		})
		this.showDataTreeSelectedArcgis(graphicsLayer)
		this.isLoading = false
	}

	public async showDataTreeSelectedArcgis(graphicsLayer): Promise<void> {
		const viewArcgis = this.viewArcgis

		viewArcgis.on('click', async event => {
			const positionTree = {
				x: event.x,
				y: event.y
			}
			const responseView = await viewArcgis.hitTest(positionTree)
			const haveResult = responseView.results.length

			if (haveResult) {
				const validate = responseView.results.filter(result => {
					return result.graphic.layer === graphicsLayer
				})

				if (validate && validate.length > 0) {
					const graphic = validate[0].graphic
					const treeId = graphic.attributes.idMongo

					this.getInfosArcGis(treeId, this.company._id, viewArcgis)
				}
			}
		})
	}

	public async getInfosArcGis(
		treeId,
		companyId,
		viewArcgis,
		locationMap = null,
		contentPopup = null
	) {
		if (locationMap != null) {
			viewArcgis.popup.open({
				content: contentPopup,
				location: locationMap
			})
		} else {
			let content

			if (this.mapType == 'plantingOpportunityMap') {
				this.treeSelected = await this.plantingService
					.getClickPlantingOpportunity(treeId, companyId)
					.toPromise()
			}
			if (this.mapType == 'plantingHistoricMap') {
				this.treeSelected = await this.plantingService
					.getClickPlanting(treeId, companyId)
					.toPromise()
			}
			if (this.mapType == 'inventoryScheduleMap') {
				this.treeSelected = await this.inventoryService
					.getScheduleTreeInfos(treeId, companyId)
					.toPromise()
			}
			if (this.mapType == 'inventoryMap') {
				this.treeSelected = await this.inventoryService
					.getClickTree(treeId, companyId)
					.toPromise()
			}
			if (this.mapType == 'scheduleAppraisalMap') {
				this.treeSelected = await this.schedulingService
					.getClickScheduleDemand(treeId, this.companyId)
					.toPromise()
			}
			if (this.mapType == 'appraisalMap') {
				this.treeSelected = await this.demandService
					.getClickTree(treeId, this.companyId)
					.toPromise()
			}
			if (this.mapType == 'operationScheduleMap') {
				this.treeSelected = await this.operationServiceService
					.getClickScheduleTree(treeId, this.companyId)
					.toPromise()
			}
			if (this.mapType == 'operationMap') {
				this.treeSelected = await this.operationServiceService
					.getClickTree(treeId, this.companyId)
					.toPromise()
			}

			content = this.createPopupForMap(this.treeSelected)

			viewArcgis.popup.open({
				content
			})
		}
	}

	public getInfosMouseClickFromTable(treeFromTable) {
		const visibleMap = localStorage.getItem('mapVisible')

		if (visibleMap && visibleMap == 'google-maps') {
			if (treeFromTable && treeFromTable.lat && treeFromTable.lng) {
				const latLng = new google.maps.LatLng(
					treeFromTable.lat,
					treeFromTable.lng
				)
				this.myMap.setCenter(latLng)
			}

			this.myMap.setZoom(21)

			this.insertPopupInGoogleMaps(treeFromTable)
		} else {
			this.viewArcgis.popup.close()
			if (treeFromTable && treeFromTable.lat && treeFromTable.lng) {
				this.viewArcgis.center = [treeFromTable.lng, treeFromTable.lat]
			}

			this.viewArcgis.zoom = 21
			setTimeout(() => {
				this.insertPopupInArcgis(treeFromTable)
			}, 600)
		}
	}

	public insertPopupInGoogleMaps(treeFromTable) {
		const markerSelected = this.markers.find(marker =>
				marker.getPosition().lat() == treeFromTable.lat &&
				marker.getPosition().lng() == treeFromTable.lng
		)

		if (markerSelected) {
			const popup = this.createPopupForMap(treeFromTable)

			this.markerInfowindow.setContent(popup)
			this.markerInfowindow.setOptions({
				disableAutoPan: true
			})

			this.markerInfowindow.open(this.myMap, markerSelected)
		}
	}

	public insertPopupInArcgis(treeFromTable) {
		const position = {
			latitude: treeFromTable.lat,
			longitude: treeFromTable.lng
		}

		const content = this.createPopupForMap(treeFromTable)

		this.getInfosArcGis(null, null, this.viewArcgis, position, content)
	}

	public getUrlFromMapType(details: DetailsFromClick): string {
		if (this.mapType == 'inventoryMap') {
			return `/protected/inventoryReportArboreal/${details.idMongo}`
		} else if (this.mapType == 'appraisalMap') {
			return `/protected/evaluationReportArboreal/${details.idMongo}`
		} else if (this.mapType == 'operationMap') {
			if (details.plantingOpportunityId) {
				return `/protected/plantingReportArboreal/${details.plantingOpportunityId}`
			} else {
				return `/protected/operationReportArboreal/${details.idMongo}`
			}
		} else if (this.mapType == 'plantingHistoricMap') {
			return `/protected/plantingReportArboreal/${details.plantingOpportunityId}`
		} else if (this.mapType == 'plantingOpportunityMap') {
			return `/protected/plantingOpportunityReportArboreal/${details.idMongo}`
		} else if (this.mapType == 'operationScheduleMap') {
			if (details.plantingOpportunityId) {
				return `/protected/plantingOpportunityReportArboreal/${details.plantingOpportunityId}`
			} else {
				return `/protected/operationServiceScheduleReportArboreal/${details.idMongo}`
			}
		}
	}

	public createPopupForMap(treeFromTable: DetailsFromClick) {
		const typeMapEnableReport = Boolean(
			this.mapType == 'inventoryMap' ||
				this.mapType == 'appraisalMap' ||
				this.mapType == 'operationMap' ||
				this.mapType == 'plantingHistoricMap' ||
				this.mapType == 'operationScheduleMap'
		)

		const userAuthorized = Boolean(
			this.isAdmin || this.hasAccessProtectedRouteReport
		)

		const enableLinkInImage = Boolean(userAuthorized && typeMapEnableReport)

		let linkToReport: string = ''

		linkToReport = this.getUrlFromMapType(treeFromTable)

		const popupBody = `<div style="display: flex; align-items: center;">
								<div class="initPoput" style="position: absolute;
															  top: 0;
															  left: 0;
															  height: 100%;
															  width: 20px;
															  background-color: ${treeFromTable.color ? treeFromTable.color : 'green'};"
								></div>
								<a style="display: ${enableLinkInImage ? 'block' : 'none'};"
								   class="link" target="_blank" ng-reflect-target="_blank" ng-reflect-router-link="${linkToReport}" href="#${linkToReport}"
								>
									<img style="width: 200px;
										 height: 200px;
										 cursor: pointer;
										 margin: ${
												localStorage.getItem('mapVisible') == 'google-maps'
													? '0 15px 0 20px'
													: '0 15px 0 -15px'
											};
										 border-radius: 20px;"
										 class="image-tree"
										 src="${
												treeFromTable.mediaUrl
													? treeFromTable.mediaUrl
													: 'assets/images/placeholder_report.svg'
											}"
									/>
								</a>
								<img style="display: ${!enableLinkInImage ? 'block' : 'none'};
											width: 200px;
											height: 200px;
											cursor: pointer;
											margin: ${
												localStorage.getItem('mapVisible') == 'google-maps'
													? '0 15px 0 20px'
													: '0 15px 0 -15px'
											};
											border-radius: 20px;"
											class="image-tree"
											src="${
												treeFromTable.mediaUrl
													? treeFromTable.mediaUrl
													: 'assets/images/placeholder_report.svg'
											}"
								/>
								<div style="max-width: 280px;">
									<p style="font-weight: bold; font-size: 18px; color: ${
										treeFromTable.color ? treeFromTable.color : 'green'
									}; display: ${
			treeFromTable.evaluation && treeFromTable.answer ? 'block' : 'none'
		};">
										${
											treeFromTable.evaluation == 'Árvore'
												? 'Árvore'
												: treeFromTable.evaluation + ':'
										} ${treeFromTable.answer}
									</p>
									<p style="margin-top: 10px; display: ${
										!treeFromTable.tree ? 'block' : 'none'
									};">
										<mark style="background-color: transparent; font-weight: bold; color: #575651;">Identificação:</mark> ${
											treeFromTable.identification
												? treeFromTable.identification
												: '-'
										}
									</p>
									<p style="margin-top: 10px; display: ${treeFromTable.tree ? 'block' : 'none'};">
										<mark style="background-color: transparent; font-weight: bold; color: #575651;">Identificação:</mark> ${
											(treeFromTable.tree &&
												treeFromTable.tree.identification) ||
											'-'
										}
									</p>
									<p style="margin-top: 10px; display: ${
										treeFromTable.tree && treeFromTable.hasIdentifier
											? 'block'
											: 'none'
									};">
										<mark style="background-color: transparent; font-weight: bold; color: #575651;">${
											treeFromTable.tree && treeFromTable.tree.identifierName
										}:</mark> ${
			(treeFromTable.tree && treeFromTable.tree.identifier) || '-'
		}
									</p>
									<p style="margin-top: 10px; display: ${
										treeFromTable.tree && treeFromTable.treeHasSpecie
											? 'block'
											: 'none'
									};">
										<mark style="background-color: transparent; font-weight: bold; color: #575651;">Espécie:</mark> ${
											(treeFromTable.tree && treeFromTable.tree.specie) || '-'
										}
									</p>
									<p style="margin-top: 10px; display: ${
										treeFromTable.tree && treeFromTable.treeHasFamily
											? 'block'
											: 'none'
									};">
										<mark style="background-color: transparent; font-weight: bold; color: #575651;">Família:</mark> ${
											(treeFromTable.tree && treeFromTable.tree.family) || '-'
										}
									</p>
									<p style="margin-top: 10px; display: ${
										treeFromTable.tree && treeFromTable.treeHasDap
											? 'block'
											: 'none'
									};">
										<mark style="background-color: transparent; font-weight: bold; color: #575651;">${
											(treeFromTable.tree && treeFromTable.tree.dapCapType) ||
											'Dap/cap'
										}:</mark> ${
			treeFromTable.tree ? treeFromTable.tree.dapCap + ' cm' : '-'
		}
									</p>
									<p style="margin-top: 10px; display: ${
										treeFromTable.tree && treeFromTable.treeHasHeight
											? 'block'
											: 'none'
									};">
										<mark style="background-color: transparent; font-weight: bold; color: #575651;">Altura total:</mark> ${
											(treeFromTable.tree &&
												treeFromTable.tree.height + ' m') ||
											'-'
										}
									</p>
									<p style="margin-top: 10px; display: ${
										treeFromTable.createDate ? 'block' : 'none'
									};">
										<mark style="background-color: transparent; font-weight: bold; color: #575651;">Cadastro:</mark> ${
											this.ViewValidation.formatDate(
												treeFromTable.createDate
											) || '-'
										}
									</p>
								</div>
							</div>`
		return popupBody
	}

	public async updateLocationPin(): Promise<void> {
		this.showPinMoveAlertModal = false;
		this.updatePin.emit({
			location: this.endLocationAfterDrag,
			idMongo: this.treeDraggedId
		})
	}

	public async searchByCepOrAddress() {
		let lat: number
		let lng: number
		let coordinates: any
		const map = this.myMap
		const iconBase: string = 'assets/images/'
		const geocoder: any = new google.maps.Geocoder()
		const visibleMap = localStorage.getItem('mapVisible')
		try {
			await geocoder.geocode(
				{ address: this.searchAddress },
				async (results, status) => {
					if (!this.searchAddress && visibleMap == 'google-maps') {
						lat = this.address.lat
						lng = this.address.lng
						coordinates = new google.maps.LatLng(lat, lng)
						map.setCenter(coordinates)
						this.myMap.setZoom(13)
						this.prevMarker.setMap(null)
						return
					} else if (!this.searchAddress) {
						lat = this.address.lat
						lng = this.address.lng
						this.viewArcgis.center = [lng, lat]
						this.viewArcgis.zoom = 13
						return
					}
					if (status === google.maps.GeocoderStatus.OK) {
						lat = results[0].geometry.location.lat()
						lng = results[0].geometry.location.lng()
						if (lat !== 0 && lng !== 0) {
							coordinates = new google.maps.LatLng(lat, lng)
							if (visibleMap && visibleMap == 'google-maps') {
								if (map.getBounds().contains(coordinates)) {
									map.panTo(coordinates)
								} else {
									map.setCenter(coordinates)
								}
								this.myMap.setZoom(18)

								const icon: any = {
									url: `${iconBase}m1.png`,
									size: new google.maps.Size(40, 40),
									origin: new google.maps.Point(0, 0),
									anchor: new google.maps.Point(20, 40),
									labelOrigin: new google.maps.Point(21, 19)
								}

								if (this.prevMarker !== null) {
									this.prevMarker.setMap(null)
								}

								const marker: google.maps.Marker = new google.maps.Marker({
									position: new google.maps.LatLng(lat, lng),
									icon: icon || '',
									animation: google.maps.Animation.DROP,
									map
								})

								this.prevMarker = marker
								map.addListener('click', () => marker.setVisible(false))
							} else {
								const [Graphic] = await loadModules(['esri/Graphic'])
								const point = {
									type: 'point',
									longitude: lng,
									latitude: lat
								}

								const symbol = {
									type: 'picture-marker',
									url: '../../../assets/images/pin-red.png',
									width: '52px',
									height: '52px'
								}

								const graphic = new Graphic({
									geometry: point,
									symbol
								})

								const graphicRef = { value: graphic }
								this.viewArcgis.popup.close()
								this.viewArcgis.center = [lng, lat]
								this.viewArcgis.zoom = 18
								if (this.previousMarker) {
									this.viewArcgis.graphics.remove(this.previousMarker)
								}
								this.previousMarker = graphicRef.value
								this.viewArcgis.graphics.add(graphic)
								this.viewArcgis.on('click', () => {
									this.viewArcgis.graphics.remove(graphicRef.value)
								})
							}
						}
					}
				}
			)
		} catch (err) {
			console.log(err)
		}
	}

	public async setFilterPerState(): Promise<void> {
		const filtersState = this.filtersData.answers.map(item => {
			return {
				...item,
				checked: false
			}
		})

		this.filterPerState = filtersState
	}

	public viewIdentificationTreeFromMap() {
		this.viewLabels = !this.viewLabels
		const visibleMap = localStorage.getItem('mapVisible')

		if (visibleMap == 'google-maps') {
			this.viewLabelForGoogle()
		} else {
			if (this.viewLabels) {
				this.addLabelsToGraphicsLayer()
			} else {
				this.removeLabelsFromGraphicsLayer()
			}
		}

		const viewNumberButton: HTMLButtonElement = document.getElementById(
			'insert-label-button'
		) as HTMLButtonElement

		if (!viewNumberButton) return

		switch (this.viewLabels) {
			case true:
				viewNumberButton.classList.add('active')
				break
			case false:
				viewNumberButton.classList.remove('active')
				break
			default:
				viewNumberButton.classList.remove('active')
		}
	}

	public viewLabelForGoogle() {
		this.markers.forEach(marker => {
			marker.setLabel(
				this.viewLabels
					? {
							text: marker.getTitle(),
							fontWeight: 'bold',
							fontSize: '12'
						}
					: null
			)
		})
	}

	// Adiciona os gráficos dos labels de volta à camada
	public async addLabelsToGraphicsLayer() {
		const filtersSelected = this.filterPerState.filter(filter => filter.checked
		)

		let trees: Array<PinMapDto> = this.allTrees

		const viewOnlyPinsSelected = Boolean(
			this.viewOnlyPinsSelected && this.idsMongoSelected.length > 0
		)

		if (viewOnlyPinsSelected) {
			trees = this.filterByIdmongoSelected()
		}

		if (filtersSelected.length > 0) {
			trees = this.filterByStateSelected(trees, filtersSelected)
		}

		const [Graphic] = await loadModules(['esri/Graphic'])

		trees.forEach(tree => {
			if (tree.lat != undefined && tree.lng !== undefined) {
				const point = {
					type: 'point',
					longitude: tree.lng,
					latitude: tree.lat
				}

				const textSymbol = {
					type: 'text',
					color: 'black',
					haloColor: 'white',
					haloSize: '1px',
					text: tree.identification,
					xoffset: 0,
					yoffset: 15,
					font: {
						size: 10,
						weight: 'bold'
					}
				}

				const textGraphic = new Graphic({
					geometry: point,
					symbol: textSymbol
				})

				this.labelsGraphics.push(textGraphic)
				this.layerlabelsForArcGis.add(textGraphic)
			}
		})
	}

	// Remove os gráficos dos labels da camada
	public removeLabelsFromGraphicsLayer() {
		this.labelsGraphics.forEach(labelGraphic => {
			this.layerlabelsForArcGis.remove(labelGraphic)
		})

		this.labelsGraphics = []
	}

	public changeViewPinsFromMap(parentCalling: boolean) {
		if (parentCalling && !this.viewOnlyPinsSelected) return

		const filtersSelected = this.filterPerState.filter(filter => filter.checked
		)

		let treesFiltered: Array<PinMapDto> = this.allTrees

		const viewOnlyPinsSelected = Boolean(
			this.viewOnlyPinsSelected && this.idsMongoSelected.length > 0
		)

		if (viewOnlyPinsSelected) {
			treesFiltered = this.filterByIdmongoSelected()
		}

		if (filtersSelected.length > 0) {
			treesFiltered = this.filterByStateSelected(treesFiltered, filtersSelected)
		}

		this.applyFilterIdMongoSelected(treesFiltered)
		setViewOnlyPinsSelected(this.viewOnlyPinsSelected)
	}

	public applyFilterIdMongoSelected(tree: Array<PinMapDto>) {
		const visibleMap = localStorage.getItem('mapVisible')

		if (visibleMap == 'google-maps') {
			this.addMarkers(this.myMap, tree)
		} else {
			this.addMarkersArcgis(this.mapArcgis, tree)
		}
	}

	public selectedState(position: number): void {
		this.filterPerState = this.filterPerState.map((filter, index) => {
			if (index === position) {
				return {
					...filter,
					checked: !filter.checked
				}
			}
			return filter
		})
	}

	public modalFilteractivate(state: boolean) {
		this.modalFilterVisible = state

		if (document.fullscreenElement) {
			setTimeout(() => {
				const filters: HTMLDivElement =
					document.getElementById('filters') as HTMLDivElement

				if (filters) {
					document.fullscreenElement.appendChild(filters)
				}
			}, 100)
		}
	}

	public async applyFilterState() {
		this.treeSelected = null
		const filtersSelected = this.filterPerState.filter(filter => filter.checked
		)

		const visibleMap = localStorage.getItem('mapVisible')

		if (this.company.isArcgis) {
			this.viewArcgis.popup.close()
		}

		let trees: Array<PinMapDto> = this.allTrees

		const viewOnlyPinsSelected = Boolean(
			this.viewOnlyPinsSelected && this.idsMongoSelected.length > 0
		)

		if (viewOnlyPinsSelected) {
			trees = this.filterByIdmongoSelected()
		}

		if (filtersSelected.length > 0) {
			trees = this.filterByStateSelected(trees, filtersSelected)
		}

		if (visibleMap == 'google-maps') {
			this.cleanPolygonAndSelectMapDataFromChangeFilter()
			this.addMarkers(this.myMap, trees)
		} else {
			this.addMarkersArcgis(this.mapArcgis, trees)
		}

		this.modalFilteractivate(false)
	}

	private cleanPolygonAndSelectMapDataFromChangeFilter() {
		this.markersSelectedFromMap = []
		this.idMongoFromSelectedMarkersFromMap = []
		this.removeStrokeFromSelectedPins('MAP')

		if (this.startedPolygon) {
			this.idMongoFromSelectedMarkersFromPolygon = []
			this.markersSelectedFromPolygon = []
			this.region.coordinates = []
			this.removePolygonFromMap()
			this.enableOrDesableBtnClear(true)
			this.removeStrokeFromSelectedPins('POLYGON')
			this.setShowOnlySelectButtonActive('select-pin-from-polygon-button')
		}
	}

	public filterByIdmongoSelected(): Array<PinMapDto> {
		const treeSelected: Array<PinMapDto> = this.allTrees.filter(tree =>
			this.idsMongoSelected.includes(tree.idMongo)
		)

		return treeSelected
	}

	public filterByStateSelected(
		trees: Array<PinMapDto>,
		filtersSelected: Array<FiltersState>
	): Array<PinMapDto> {
		let treeSelected: Array<PinMapDto> = []

		if (this.mapType != 'operationMap') {
			treeSelected = trees.filter(tree => {
				return filtersSelected.some(selectedFilter =>
						tree.answer.toLowerCase() === selectedFilter.text.toLowerCase()
				)
			})
		} else {
			const filters: Array<string> = []

			filtersSelected.forEach(filter => {
				filters.push(filter.text)
			})

			treeSelected = trees.filter(tree => {
				return filters.some(filter => tree.handleOperations.includes(filter))
			})
		}

		return treeSelected
	}

	public async fetchCompany(): Promise<void> {
		try {
			this.company = await this.companyService
				.detailCompany(this.companyId)
				.toPromise()

			this.isArcgis = this.company.mandatoryArcGis
		} catch (err) {}
	}

	public fetchSessionUser(): void {
		this.sessionUser.assignments.forEach(assignment => {
			this.assignments.push(assignment)
		})

		this.isAdmin = Boolean(this.sessionUser.roles.includes('GENERAL_ADMIN'))

		if (this.mapType == 'inventoryMap') {
			this.enableButtonUpdateCache = Boolean(
				this.isAdmin ||
					this.sessionUser.assignments.includes(
						'INVENTORY_HISTORY_UPDATE_MAP_CACHE'
					)
			)

			this.dragAuthorized = Boolean(
				this.sessionUser.assignments.includes(
					'INVENTORY_HISTORY_DRAG_ALL_PIN_MAP'
				)
			)

			this.hasAccessProtectedRouteReport = Boolean(
				this.assignments.includes('INVENTORY_REPORT_READ')
			)
		} else if (this.mapType == 'scheduleAppraisalMap') {
			this.enableButtonUpdateCache = Boolean(
				this.isAdmin ||
					this.sessionUser.assignments.includes('APPRAISAL_SCHEDULE_UPDATE')
			)

			this.dragAuthorized = Boolean(
				this.sessionUser.assignments.includes('APPRAISAL_SCHEDULE_DRAG_PIN_MAP')
			)
		} else if (this.mapType == 'appraisalMap') {
			this.enableButtonUpdateCache = Boolean(
				this.isAdmin ||
					this.sessionUser.assignments.includes(
						'APPRAISAL_HISTORY_UPDATE_MAP_CACHE'
					)
			)

			this.dragAuthorized = Boolean(
				this.sessionUser.assignments.includes(
					'APPRAISAL_HISTORY_DRAG_ALL_PIN_MAP'
				)
			)

			this.hasAccessProtectedRouteReport = Boolean(
				this.assignments.includes('APPRAISAL_REPORT_READ')
			)
		} else if (this.mapType == 'operationMap') {
			this.enableButtonUpdateCache = Boolean(
				this.isAdmin ||
					this.sessionUser.assignments.includes(
						'OPERATION_SERVICE_HISTORY_UPDATE_MAP_CACHE'
					)
			)

			this.dragAuthorized = Boolean(
				this.sessionUser.assignments.includes(
					'OPERATION_SERVICE_HISTORY_DRAG_ALL_PIN_MAP'
				)
			)

			this.hasAccessProtectedRouteReport = Boolean(
				this.assignments.includes('OPERATION_SERVICE_REPORT_READ')
			)
		} else if (this.mapType == 'operationScheduleMap') {
			this.enableButtonUpdateCache = Boolean(
				this.isAdmin ||
					this.sessionUser.assignments.includes(
						'OPERATION_SERVICE_SCHEDULE_UPDATE_MAP_CACHE'
					)
			)

			this.dragAuthorized = Boolean(
				this.sessionUser.assignments.includes(
					'OPERATION_SERVICE_SCHEDULE_DRAG_PIN_MAP'
				)
			)

			this.hasAccessProtectedRouteReport = Boolean(
				this.assignments.includes('OPERATION_SERVICE_REPORT_READ')
			)
		} else if (this.mapType == 'plantingHistoricMap') {
			this.enableButtonUpdateCache = Boolean(
				this.isAdmin ||
					this.sessionUser.assignments.includes(
						'PLANTING_HISTORY_UPDATE_MAP_CACHE'
					)
			)

			this.dragAuthorized = Boolean(
				this.sessionUser.assignments.includes(
					'PLANTING_HISTORY_DRAG_ALL_PIN_MAP'
				)
			)

			this.hasAccessProtectedRouteReport = Boolean(
				this.assignments.includes('PLANTING_REPORT_READ')
			)
		} else if (this.mapType == 'plantingOpportunityMap') {
			this.enableButtonUpdateCache = Boolean(
				this.isAdmin ||
					this.sessionUser.assignments.includes(
						'PLANTING_SCHEDULE_UPDATE_MAP_CACHE'
					)
			)

			this.dragAuthorized = Boolean(
				this.sessionUser.assignments.includes(
					'PLANTING_SCHEDULE_DRAG_ALL_PIN_MAP'
				)
			)

			this.hasAccessProtectedRouteReport = Boolean(
				this.assignments.includes('PLANTING_REPORT_READ')
			)
		} else if (this.mapType == 'inventoryScheduleMap') {
			this.enableButtonUpdateCache = Boolean(
				this.isAdmin ||
					this.sessionUser.assignments.includes(
						'INVENTORY_SCHEDULE_UPDATE_MAP_CACHE'
					)
			)

			this.dragAuthorized = Boolean(
				this.sessionUser.assignments.includes(
					'INVENTORY_SCHEDULE_DRAG_ALL_PIN_MAP'
				)
			)
		}
	}

	public requestMapCacheUpdate() {
		this.isLoading = true
		this.requestCacheUpdate.emit()
		this.cleanPolygonAndSelectMapDataFromChangeFilter()
		this.closeModalOutOfDateWithPermission()
	}

	public async updateMapCache() {
		const visibleMap = localStorage.getItem('mapVisible')

		if (visibleMap == 'google-maps') {
			this.addMarkers(this.myMap, this.allTrees)
		} else {
			this.addMarkersArcgis(this.mapArcgis, this.allTrees)
		}
	}

	public removeStrokeFromSelectedPins(type: 'MAP' | 'POLYGON') {
		if (type == 'MAP') {
			this.markersSelectedFromMap.forEach(marker => {
				const markerIcon = marker.getIcon() as google.maps.Icon
				marker.setIcon({
					...markerIcon,
					strokeColor: '#000000',
					strokeWeight: 0
				})
			})
		} else {
			this.markersSelectedFromPolygon.forEach(marker => {
				const markerIcon = marker.getIcon() as google.maps.Icon
				marker.setIcon({
					...markerIcon,
					strokeColor: '#000000',
					strokeWeight: 0
				})
			})
		}
	}

	public getPinIcon(
		dap: number,
		colorPin: string,
		isPinSelected: boolean = false
	) {
		let svg: {
			path: string
			fillColor: string
			fillOpacity: number
			scale: number
			strokeWeight: number
			stroke?: string
		}

		if (dap > 45) {
			svg = {
				path: 'M109 165 c-14 -8 -32 -28 -39 -45 -17 -42 5 -91 49 -110 67 -28 139 43 111 110 -12 30 -55 60 -82 60 -7 -1 -25 -7 -39 -15z',
				fillColor: colorPin,
				fillOpacity: 1,
				scale: 0.1,
				strokeWeight: 0
			}
		} else if (dap >= 25 && dap <= 45) {
			svg = {
				path: 'M103 145 c-72 -50 -6 -169 76 -135 77 32 54 150 -29 150 -14 0 -35 -7 -47 -15z',
				fillColor: colorPin,
				fillOpacity: 1,
				scale: 0.095,
				strokeWeight: 0
			}
		} else if (dap >= 10 && dap < 25) {
			svg = {
				path: 'M103 145 c-72 -50 -6 -169 76 -135 77 32 54 150 -29 150 -14 0 -35 -7 -47 -15z',
				fillColor: colorPin,
				fillOpacity: 1,
				scale: 0.085,
				strokeWeight: 0
			}
		} else {
			svg = {
				path: 'M103 145 c-72 -50 -6 -169 76 -135 77 32 54 150 -29 150 -14 0 -35 -7 -47 -15z',
				fillColor: colorPin,
				fillOpacity: 1,
				scale: 0.07,
				strokeWeight: 0
			}
		}

		if (isPinSelected) {
			svg.stroke = '#000000'
			svg.strokeWeight = 3
		}

		return svg
	}

	public toggleLayerSatelite(): void {
		this.layerMapArcgis =
			this.layerMapArcgis != 'arcgis-imagery'
				? 'arcgis-topographic'
				: 'arcgis-imagery'
		this.mapArcgis.basemap = this.layerMapArcgis
	}

	public async toggleTypesLayerMap(): Promise<void> {
		const element = document.getElementsByClassName('esri-basemap-gallery')[0]
		if (element.classList.contains('show-basemap')) {
			element.classList.remove('show-basemap')
			return
		}
		element.classList.add('show-basemap')
	}

	public screenWithCustomerBread() {
		this.withCustomerBread = Boolean(
			document.getElementsByClassName('customer-bread').length > 0
		)
	}

	public getRandomColor() {
		const letters = '0123456789ABCDEF'.split('')
		let color = '#'
		for (let i = 0; i < 6; i++) {
			color += letters[Math.floor(Math.random() * 16)]
		}
		return color
	}

	public async fetchRegions() {
		try {
			this.allRegions = await this.regionsService
				.getRegionsFromMapByCompanyId(this.companyId)
				.toPromise()
		} catch (err) {}
	}

	public insertShowRegionsButtonInGooleMaps() {
		const iconBase: string = 'assets/images/icon/hide-icon.svg'
		const svgIcon = document.createElement('img')
		svgIcon.setAttribute('id', 'img-show-all-regions')
		svgIcon.setAttribute('src', iconBase)

		const button = document.createElement('button')

		const handleClickButton = () => {
			this.viewAllRegionsInMap = !this.viewAllRegionsInMap
			this.switchShowHideRegionsInMap()
			this.updateImageButtonShowHideRegions()
		}

		button.setAttribute('class', 'btn-google-maps regions-button with-balloon')
		button.appendChild(svgIcon)

		const ballonBase: string = 'assets/images/balloon-regions.svg'
		const ballon = document.createElement('img')
		ballon.style.display = 'none'

		ballon.setAttribute('src', ballonBase)

		const divContent = document.createElement('div')
		divContent.setAttribute('class', 'conteiner-button')

		divContent.appendChild(ballon)
		divContent.appendChild(button)

		button.addEventListener('mouseover', () => {
			ballon.style.display = 'block'
		})

		button.addEventListener('mouseout', () => {
			ballon.style.display = 'none'
		})

		button.addEventListener('click', () => {
			handleClickButton()
		})

		this.myMap.controls[google.maps.ControlPosition.RIGHT_TOP].push(divContent)
	}

	public insertFilterButtonInGooleMaps() {
		const iconBase: string = 'assets/images/icon/filter-icon.svg'
		const svgIcon = document.createElement('img')
		svgIcon.setAttribute('src', iconBase)

		const button = document.createElement('button')

		const handleClickButton = () => {
			this.modalFilteractivate(!this.modalFilterVisible)
		}

		button.setAttribute('class', 'btn-google-maps regions-button with-balloon')
		button.appendChild(svgIcon)

		const ballonBase: string = 'assets/images/balloon-filters.svg'
		const ballon = document.createElement('img')
		ballon.style.display = 'none'

		ballon.setAttribute('src', ballonBase)

		const divContent = document.createElement('div')
		divContent.setAttribute('class', 'conteiner-button')

		divContent.appendChild(ballon)
		divContent.appendChild(button)

		button.addEventListener('mouseover', () => {
			ballon.style.display = 'block'
		})

		button.addEventListener('mouseout', () => {
			ballon.style.display = 'none'
		})

		button.addEventListener('click', () => {
			handleClickButton()
		})

		this.myMap.controls[google.maps.ControlPosition.RIGHT_TOP].push(divContent)
	}

	public insertRefreshMapButtonInGooleMaps() {
		const iconBase: string = 'assets/images/icon/refresh-icon.svg'
		const svgIcon = document.createElement('img')
		svgIcon.setAttribute('id', 'refresh-map-button')
		svgIcon.setAttribute('src', iconBase)

		const button = document.createElement('button')

		const handleClickButton = () => {
			this.requestMapCacheUpdate()
		}

		button.setAttribute('class', 'btn-google-maps refresh-button')
		button.title = 'Atualizar mapa'
		button.appendChild(svgIcon)

		button.addEventListener('click', () => {
			handleClickButton()
		})

		this.myMap.controls[google.maps.ControlPosition.TOP_LEFT].push(button)
	}

	public insertShowOnlySelectedButtonInGoogleMaps() {
		const iconBase: string = 'assets/images/icon/only-selected-icon.svg'
		const svgIcon = document.createElement('img')
		svgIcon.setAttribute('src', iconBase)

		const button = document.createElement('button')

		const handleClickButton = () => {
			this.viewOnlyPinsSelected = !this.viewOnlyPinsSelected
			this.changeViewPinsFromMap(false)
			this.setShowOnlySelectButtonActive('only-selected-map-button')
		}

		button.setAttribute('class', 'btn-google-maps regions-button with-balloon')
		button.setAttribute('id', 'only-selected-map-button')
		button.disabled =
			this.idsMongoSelected.length == 0 || !this.viewOnlyPinsSelected
		button.appendChild(svgIcon)

		const ballonBase: string = 'assets/images/balloon-only-select.svg'
		const ballon = document.createElement('img')
		ballon.style.display = 'none'

		ballon.setAttribute('src', ballonBase)

		const divContent = document.createElement('div')
		divContent.setAttribute('class', 'conteiner-button')

		divContent.appendChild(ballon)
		divContent.appendChild(button)

		button.addEventListener('mouseover', () => {
			ballon.style.display = 'block'
		})

		button.addEventListener('mouseout', () => {
			ballon.style.display = 'none'
		})

		button.addEventListener('click', () => {
			handleClickButton()
		})

		this.myMap.controls[google.maps.ControlPosition.RIGHT_TOP].push(divContent)
	}

	public insertGroupPinsButtonInGoogleMaps() {
		const iconBase: string = 'assets/images/icon/group-pin-icon.svg'
		const svgIcon = document.createElement('img')
		svgIcon.setAttribute('src', iconBase)

		const button = document.createElement('button')

		const handleClickButton = () => {
			this.viewMarkersClusterided = !this.viewMarkersClusterided
			this.clusteredPins()
			this.setShowOnlySelectButtonActive('group-pin-button')
		}

		button.setAttribute('class', 'btn-google-maps regions-button with-balloon')
		button.setAttribute('id', 'group-pin-button')
		button.appendChild(svgIcon)

		const ballonBase: string = 'assets/images/balloon-group.svg'
		const ballon = document.createElement('img')
		ballon.style.display = 'none'

		ballon.setAttribute('src', ballonBase)

		const divContent = document.createElement('div')
		divContent.setAttribute('class', 'conteiner-button')

		divContent.appendChild(ballon)
		divContent.appendChild(button)

		button.addEventListener('mouseover', () => {
			ballon.style.display = 'block'
		})

		button.addEventListener('mouseout', () => {
			ballon.style.display = 'none'
		})

		button.addEventListener('click', () => {
			handleClickButton()
		})

		this.myMap.controls[google.maps.ControlPosition.RIGHT_TOP].push(divContent)

		this.cleanPolygonAndSelectMapDataFromChangeFilter()
	}

	private handleInsertSelectPinsInGoogleMapsByPolygon = () => {
		if (
			this.region.coordinates.length != 0 ||
			this.disableSelectMarkersFromPolygonIfZoomIsLessThanSixteen
		) {
			return
		}

		this.isEnabledSelectMarkersFromPolygon =
			!this.isEnabledSelectMarkersFromPolygon

		this.setShowOnlySelectButtonActive('select-pin-from-polygon-button')

		if (
			!this.isEnabledSelectMarkersFromPolygon &&
			this.region.coordinates.length == 0
		) {
			this.removePolygons()

			this.myMap.setOptions({
				gestureHandling: 'cooperative',
				zoomControl: true,
				disableDoubleClickZoom: false,
				streetViewControl: true
			})
		} else if (this.isEnabledSelectMarkersFromPolygon) {
			this.insertPolygonToolInMap()

			this.myMap.setOptions({
				gestureHandling: 'none',
				zoomControl: false,
				disableDoubleClickZoom: true,
				streetViewControl: false
			})
		}

		if (!this.startedPolygon) {
			this.startPolygons()
		}

		this.markersSelectedFromPolygon = []
		this.idMongoFromSelectedMarkersFromPolygon = []
	}

	// Select schedule from map

	public insertSelectPinsInGoogleMapsByPolygon() {
		const iconBase: string =
			'assets/images/icon/select-schedule-map/draw-polygon.svg'
		const svgIcon = document.createElement('img')
		svgIcon.setAttribute('src', iconBase)

		const button = document.createElement('button')

		button.setAttribute(
			'class',
			'btn-google-maps regions-button relative-position'
		)
		button.setAttribute('id', 'select-pin-from-polygon-button')
		button.setAttribute('disabled', 'true')

		button.appendChild(svgIcon)

		const ballonBaseDisabled: string =
			'assets/images/icon/select-schedule-map/balloon-draw-polygon-disabled.svg'
		const ballonBase: string =
			'assets/images/icon/select-schedule-map/balloon-draw-polygon.svg'

		const ballon = document.createElement('img')
		ballon.style.display = 'none'
		ballon.setAttribute('src', ballonBase)

		const ballonDisabled = document.createElement('img')
		ballonDisabled.style.display = 'none'
		ballonDisabled.setAttribute('src', ballonBaseDisabled)

		const divContent = document.createElement('div')
		divContent.setAttribute('class', 'conteiner-button')

		divContent.appendChild(button)
		divContent.appendChild(ballonDisabled)
		divContent.appendChild(ballon)

		button.addEventListener('mouseover', () => {
			if (this.disableSelectMarkersFromPolygonIfZoomIsLessThanSixteen) {
				ballonDisabled.style.display = 'block'
			} else {
				ballon.style.display = 'block'
			}
		})

		button.addEventListener('mouseout', () => {
			if (this.disableSelectMarkersFromPolygonIfZoomIsLessThanSixteen) {
				ballonDisabled.style.display = 'none'
			} else {
				ballon.style.display = 'none'
			}
		})

		button.addEventListener('click', () => {
			this.handleInsertSelectPinsInGoogleMapsByPolygon()
		})

		this.myMap.controls[google.maps.ControlPosition.LEFT_BOTTOM].push(
			divContent
		)
	}

	public insertSelectPinsInGoogleMaps() {
		const iconBase: string =
			'assets/images/icon/select-schedule-map/mouse-select.svg'
		const svgIcon = document.createElement('img')
		svgIcon.setAttribute('src', iconBase)

		const button = document.createElement('button')

		const handleClickButton = () => {
			this.isEnabledSelectMarkersFromMap = !this.isEnabledSelectMarkersFromMap

			this.setShowOnlySelectButtonActive('select-pin-from-map-button')

			if (!this.isEnabledSelectMarkersFromMap) {
				this.removeStrokeFromSelectedPins('MAP')
			}

			this.markersSelectedFromMap = []
			this.idMongoFromSelectedMarkersFromMap = []
		}

		button.setAttribute(
			'class',
			'btn-google-maps regions-button relative-position'
		)
		button.setAttribute('id', 'select-pin-from-map-button')
		button.appendChild(svgIcon)

		const ballonBase: string =
			'assets/images/icon/select-schedule-map/balloon-mouse-select.svg'
		const ballon = document.createElement('img')
		ballon.style.display = 'none'

		ballon.setAttribute('src', ballonBase)

		const divContent = document.createElement('div')
		divContent.setAttribute('class', 'conteiner-button')

		divContent.appendChild(button)
		divContent.appendChild(ballon)

		button.addEventListener('mouseover', () => {
			ballon.style.display = 'block'
		})

		button.addEventListener('mouseout', () => {
			ballon.style.display = 'none'
		})

		button.addEventListener('click', () => {
			handleClickButton()
		})

		this.myMap.controls[google.maps.ControlPosition.LEFT_BOTTOM].push(
			divContent
		)
	}

	public insertClearButtonInGoogleMaps() {
		const iconBase: string =
			'assets/images/icon/select-schedule-map/clean-polygon.svg'
		const svgIcon = document.createElement('img')
		svgIcon.setAttribute('src', iconBase)

		const button = document.createElement('button')

		button.setAttribute(
			'class',
			'btn-google-maps regions-button relative-position'
		)
		button.setAttribute('id', 'btn-clear-coordinates-region')
		button.setAttribute('style', 'background: rgba(231, 23, 55, 1)')

		button.disabled = !Boolean(
			this.region &&
				this.region.coordinates &&
				this.region.coordinates &&
				this.region.coordinates.length >= 3
		)

		const ballonBase: string =
			'assets/images/icon/select-schedule-map/balloon-clean-polygon.svg'
		const ballon = document.createElement('img')
		ballon.style.display = 'none'

		ballon.setAttribute('src', ballonBase)

		button.appendChild(svgIcon)

		const divContent = document.createElement('div')
		divContent.setAttribute('class', 'conteiner-button')

		divContent.appendChild(button)
		divContent.appendChild(ballon)

		button.addEventListener('mouseover', () => {
			ballon.style.display = 'block'
		})

		button.addEventListener('mouseout', () => {
			ballon.style.display = 'none'
		})

		button.addEventListener('click', () => {
			this.clearCoordinates()
			this.removeStrokeFromSelectedPins('POLYGON')
			this.markersSelectedFromPolygon = []
			this.idMongoFromSelectedMarkersFromPolygon = []

			this.setShowOnlySelectButtonActive('select-pin-from-polygon-button')
		})

		this.myMap.controls[google.maps.ControlPosition.LEFT_BOTTOM].push(
			divContent
		)
	}

	public removePolygons() {
		this.removePolygonFromMap()
		this.removePolygonToolFromMap()
		this.enableOrDesableBtnClear(true)
		this.region.coordinates = []
	}

	public startPolygons() {
		this.startedPolygon = true
		this.insertPolygonToolInMap()

		const handlefunction = (polygon: google.maps.Polygon) => {
			this.myMap.setOptions({
				gestureHandling: 'cooperative',
				zoomControl: true,
				disableDoubleClickZoom: false,
				streetViewControl: true
			})

			this.polygonDelimitRegion = polygon

			const coordinates: Array<google.maps.LatLng> = polygon
				.getPath()
				.getArray()
				.map(coordinates => {
					return coordinates
				})

			this.region.coordinates = coordinates
			this.insertPolygonInMap()
			this.removePolygonToolFromMap()
			this.enableOrDesableBtnClear(false)
			this.fillColor()
			this.getMarkersInsidePolygon(polygon)
			this.isEnabledSelectMarkersFromPolygon = false
		}

		google.maps.event.addListener(
			this.createPolygonTool,
			'polygoncomplete',
			function(polygon: google.maps.Polygon) {
				handlefunction(polygon)
			}
		)
	}

	public insertIdentificationTreeButtonInGoogleMaps() {
		const iconBase: string = 'assets/images/icon/number-icon.svg'
		const svgIcon = document.createElement('img')
		svgIcon.setAttribute('src', iconBase)

		const button = document.createElement('button')

		const handleClickButton = () => {
			this.viewIdentificationTreeFromMap()
		}

		button.setAttribute('class', 'btn-google-maps regions-button')
		button.setAttribute('id', 'insert-label-button')
		button.appendChild(svgIcon)

		button.addEventListener('click', () => {
			handleClickButton()
		})

		this.myMap.controls[google.maps.ControlPosition.RIGHT_TOP].push(button)
	}

	public enableOrDisableShowOnlySelectButton() {
		const onlySelectButton: HTMLButtonElement = document.getElementById(
			'only-selected-map-button'
		) as HTMLButtonElement

		if (onlySelectButton) {
			onlySelectButton.disabled = this.idsMongoSelected.length == 0
		}

		this.setShowOnlySelectButtonActive('only-selected-map-button')
	}

	public setShowOnlySelectButtonActive(
		buttonId:
			| 'only-selected-map-button'
			| 'group-pin-button'
			| 'select-pin-from-map-button'
			| 'select-pin-from-polygon-button'
	) {
		const onlySelectButton: HTMLButtonElement = document.getElementById(
			buttonId
		) as HTMLButtonElement

		if (!onlySelectButton) return

		if (buttonId == 'only-selected-map-button') {
			if (this.viewOnlyPinsSelected) {
				onlySelectButton.classList.add('active')
			} else {
				onlySelectButton.classList.remove('active')
			}
		} else if (buttonId == 'group-pin-button') {
			if (this.viewMarkersClusterided) {
				onlySelectButton.classList.add('active')
			} else {
				onlySelectButton.classList.remove('active')
			}
		} else if (buttonId == 'select-pin-from-map-button') {
			if (this.isEnabledSelectMarkersFromMap) {
				onlySelectButton.classList.add('active')
			} else {
				onlySelectButton.classList.remove('active')
			}
		} else if (buttonId == 'select-pin-from-polygon-button') {
			if (
				this.isEnabledSelectMarkersFromPolygon ||
				this.region.coordinates.length >= 3
			) {
				onlySelectButton.classList.add('active')
			} else {
				onlySelectButton.classList.remove('active')
			}
		}
	}

	public scheduleFromMap() {
		if (
			this.idMongoFromSelectedMarkersFromMap.length == 0 &&
			this.idMongoFromSelectedMarkersFromPolygon.length == 0
		) {
			this.notificationService.notify(
				'Selecione pelo menos um pin para agendar',
				400
			)
			return
		}

		if (
			this.mapType != 'inventoryScheduleMap' &&
			this.mapType != 'operationScheduleMap' &&
			this.mapType != 'plantingOpportunityMap' &&
			this.mapType != 'scheduleAppraisalMap'
		) {
			this.notificationService.notify('Esse mapa não permite agendar', 400)
			return
		}

		const mapType =
			this.mapType == 'inventoryScheduleMap'
				? 'INVENTORY'
				: this.mapType == 'operationScheduleMap'
				? 'OPERATION'
				: this.mapType == 'plantingOpportunityMap'
				? 'PLANTING'
				: 'APPRAISAL'
		const ids = Array.from(
			new Set([
				...this.idMongoFromSelectedMarkersFromMap,
				...this.idMongoFromSelectedMarkersFromPolygon
			])
		)

		this.schedulingService.validateData(ids, mapType).subscribe(isValid => {
			if (!isValid) {
				if (this.enableButtonUpdateCache) {
					this.showModalOutOfDateWithPermission = true
				} else {
					this.showModalOutOfDateWithoutPermission = true
				}

				return
			}

			let navigateTo = null

			if (this.mapType == 'inventoryScheduleMap') {
				if (
					!this.scheduleMaps.find(map => map.mapName == 'inventoryScheduleMap'
					).hasPermission
				) {
					this.notificationService.notify(
						'Você não tem permissão para agendar',
						400
					)
					return
				}

				localStorage.setItem('inventories', JSON.stringify(ids))

				navigateTo = '/panel/inventory/pre-schedule'
			} else if (this.mapType == 'operationScheduleMap') {
				if (
					!this.scheduleMaps.find(map => map.mapName == 'operationScheduleMap'
					).hasPermission
				) {
					this.notificationService.notify(
						'Você não tem permissão para agendar',
						400
					)
					return
				}

				localStorage.setItem('operationService', JSON.stringify(ids))

				navigateTo = '/panel/operation/pre-schedule'
			} else if (this.mapType == 'plantingOpportunityMap') {
				if (
					!this.scheduleMaps.find(map => map.mapName == 'plantingOpportunityMap'
					).hasPermission
				) {
					this.notificationService.notify(
						'Você não tem permissão para agendar',
						400
					)
					return
				}

				localStorage.setItem('planting', JSON.stringify(ids))

				navigateTo = '/panel/planting-operation/operation'
			} else if (this.mapType == 'scheduleAppraisalMap') {
				if (
					!this.scheduleMaps.find(map => map.mapName == 'scheduleAppraisalMap'
					).hasPermission
				) {
					this.notificationService.notify(
						'Você não tem permissão para agendar',
						400
					)
					return
				}

				localStorage.setItem('demand', JSON.stringify(ids))

				navigateTo = '/panel/appraisal/evaluation/steps'
			}

			localStorage.setItem('cameFromScheduleMap', 'true')

			if (navigateTo) {
				this.router.navigate([navigateTo])
			}
		})
	}

	public createAllRegions() {
		if (this.polygonsDelimitAllRegions.length > 0) return

		this.allRegions.forEach(region => {
			if (!region.coordinates) {
				console.log('Region without coordinates', region.name)
				return
			}

			const polygon = new google.maps.Polygon({
				strokeOpacity: 0.6,
				strokeWeight: 2,
				fillColor: region.color,
				fillOpacity: 0.5,
				paths: region.coordinates
			})

			polygon.addListener('click', event => {
				const clickLatLng = event.latLng

				if (!this.regionInfoWindow) {
					this.regionInfoWindow = new google.maps.InfoWindow()
				}

				this.regionInfoWindow.setContent(region.name)
				this.regionInfoWindow.setPosition(clickLatLng)
				this.regionInfoWindow.open(this.myMap)
				this.markerInfowindow.close()
			})

			this.polygonsDelimitAllRegions.push(polygon)
		})
	}

	public switchShowHideRegionsInMap() {
		if (this.viewAllRegionsInMap) {
			this.showAllRegionsInMap()
		} else {
			this.hideAllRegionsInMap()
		}
	}

	public showAllRegionsInMap() {
		this.polygonsDelimitAllRegions.forEach(poligon => {
			poligon.setMap(this.myMap)
		})
	}

	public hideAllRegionsInMap() {
		this.polygonsDelimitAllRegions.forEach(poligon => {
			poligon.setMap(null)
		})

		this.regionInfoWindow.close()
	}

	public updateImageButtonShowHideRegions() {
		const iconBase: string = `assets/images/icon/${
			this.viewAllRegionsInMap ? 'hide-icon' : 'show-icon'
		}.svg`

		const imageButton: HTMLImageElement = document.getElementById(
			'img-show-all-regions'
		) as HTMLImageElement

		if (imageButton) {
			imageButton.setAttribute('src', iconBase)
		}
	}

	public removeWhiteConteiner() {
		const mapContent = document.querySelector('.map-content')

		if (mapContent) {
			const conteiner = mapContent.querySelectorAll('.conteiner')

			if (conteiner.length > 1) {
				conteiner[1].remove()
			}
		}
	}

	public closeModalLimitSelection() {
		this.showModalLimitSelection = false
	}

	public closeModalOutOfDateWithPermission() {
		this.showModalOutOfDateWithPermission = false
	}

	public closeModalOutOfDateWithoutPermission() {
		this.showModalOutOfDateWithoutPermission = false
	}

	public userAuthorizedToDrag(responsibleId?: string): boolean {
		const userIsOwner: boolean = Boolean(this.sessionUser._id == responsibleId)
		let dragAuthorized: boolean = false

		if (this.mapType == 'inventoryMap') {
			dragAuthorized = Boolean(
				this.sessionUser.assignments.includes(
					'INVENTORY_HISTORY_DRAG_PIN_MAP'
				) && userIsOwner
			)
		} else if (this.mapType == 'inventoryScheduleMap') {
			dragAuthorized = Boolean(
				this.sessionUser.assignments.includes(
					'INVENTORY_SCHEDULE_DRAG_PIN_MAP'
				) && userIsOwner
			)
		} else if (this.mapType == 'plantingHistoricMap') {
			dragAuthorized = Boolean(
				this.sessionUser.assignments.includes(
					'PLANTING_HISTORY_DRAG_PIN_MAP'
				) && userIsOwner
			)
		} else if (this.mapType == 'plantingOpportunityMap') {
			dragAuthorized = Boolean(
				this.sessionUser.assignments.includes(
					'PLANTING_SCHEDULE_DRAG_PIN_MAP'
				) && userIsOwner
			)
		} else if (this.mapType == 'appraisalMap') {
			dragAuthorized = Boolean(
				this.sessionUser.assignments.includes(
					'APPRAISAL_HISTORY_DRAG_PIN_MAP'
				) && userIsOwner
			)
		} else if (this.mapType == 'operationMap') {
			dragAuthorized = Boolean(
				this.sessionUser.assignments.includes(
					'OPERATION_SERVICE_HISTORY_DRAG_PIN_MAP'
				) && userIsOwner
			)
		} else if (this.mapType == 'operationScheduleMap') {
			dragAuthorized = Boolean(
				this.sessionUser.assignments.includes(
					'OPERATION_SERVICE_SCHEDULE_DRAG_PIN_MAP'
				)
			)
		}

		return dragAuthorized
	}
	
	public closeAlertDraggedModal() {
		this.markerDragged.setPosition({
			lat: this.startLocationBeforeDrag.lat,
			lng: this.startLocationBeforeDrag.lng
		});

		this.showPinMoveAlertModal = false;
		this.startLocationBeforeDrag = new Address();
		this.endLocationAfterDrag = new Address();
	}
}
